import type { IAPI } from '../../apiResponse';
import type { IBrowseCollectionsData } from '../browseCollections';
import { browseCollectionsResponseSchema } from '../browseCollections';

export const listFeaturedCollectionsV2ResponseSchema = browseCollectionsResponseSchema;

export type IListFeaturedCollectionsV2Response = IAPI<IBrowseCollectionsData>;
